import { render, staticRenderFns } from "./featured-alternative.vue?vue&type=template&id=5166ccf2"
import script from "./featured-alternative.vue?vue&type=script&lang=js"
export * from "./featured-alternative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports